import { render, staticRenderFns } from "./PaymentsCoffeshop.vue?vue&type=template&id=6ffb0470"
import script from "./PaymentsCoffeshop.vue?vue&type=script&lang=js"
export * from "./PaymentsCoffeshop.vue?vue&type=script&lang=js"
import style0 from "./PaymentsCoffeshop.vue?vue&type=style&index=0&id=6ffb0470&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports